import {useRoute, useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {StyleSheet} from 'react-native';
import {getSubjectDetails} from '../../apis';
import {getImage} from '../../helpers/general';
import {getSubjectName, px, useAsync, useIsLandscape} from '../../utils';
import {AppLoadingIndicator, Page} from '../components';
import Cover from './components/Cover';
import TeacherProfileModal from './components/TeacherProfileModal';
import Teachers from './components/Teachers';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';

const SubjectDetails = ({landscapeParams, onBackPressed}) => {
  const navigation = useNavigation();
  const [teacherProfileModalData, setTeacherProfileModalData] = useState();
  const {params} = useRoute();
  const isLandscape = useIsLandscape();
  const {id, name, image, languageCode, subjectType} =
    landscapeParams?.data || params?.data;

  const subjectName = getSubjectName(name, languageCode, subjectType);

  const {loading, value: details} = useAsync(async () => {
    setTeacherProfileModalData(undefined);
    return getSubjectDetails(id);
  }, [id]);

  if (!id || id === 'undefined') {
    navigation.navigate(AUTHENTICATED_ROUTES.main.path);
    return null;
  }

  const teachersData = details?.teachers || [];

  if (isLandscape && Boolean(teacherProfileModalData)) {
    return (
      <TeacherProfileModal
        data={teacherProfileModalData}
        onClose={() => setTeacherProfileModalData(undefined)}
      />
    );
  }

  return (
    <>
      <Page
        header={{
          title: 'Subject Details',
          showBackAction: true,
          onModalBackPressed: onBackPressed,
        }}
        scrollViewStyle={styles.container}
        useSidebarView={isLandscape}>
        <Cover imageUrl={getImage(image)} title={subjectName} />
        {loading ? (
          <AppLoadingIndicator />
        ) : (
          <Teachers
            teachers={teachersData}
            onTeacherPress={(teacherData) =>
              setTeacherProfileModalData(teacherData)
            }
          />
        )}
      </Page>
      {!isLandscape && Boolean(teacherProfileModalData) && (
        <TeacherProfileModal
          data={teacherProfileModalData}
          onClose={() => setTeacherProfileModalData(undefined)}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: px(50),
  },
});

export default SubjectDetails;
